<template>
  <div class="title">
    工作{{ isSpecific ? '' : ' | 实习' }}经历
    <el-tag v-if="isSpecific" type="danger">必填</el-tag>
    <info text="从最近工作经历开始填写" />
    <el-button
      v-show="!visible"
      type="primary"
      size="mini"
      plain
      style="margin-left: 50px"
      :disabled="!canEdit"
      :title="canEdit ? '' : isSpecific ? '投递岗位后无法再更改简历' : '请取消投递后再更改简历'"
      @click="editFunc"
      >添加</el-button
    >
  </div>
  <div v-if="workList.length === 0 && !visible" class="desc">工作经历最能体现您丰富的阅历和出众的工作能力！</div>
  <div v-show="!visible">
    <div v-for="item in workList" :key="item.id" class="edu_item">
      <div class="left">
        <div class="part1">
          <div>{{ item.workUnit }}</div>
          <div>
            {{ item.position }}
            <!-- | {{ item.department }} -->
          </div>
          <div>
            {{ formatDate('YYYY年MM月', new Date(item.startDate)) }}-
            {{ formatDate('YYYY年MM月', new Date(item.endDate)) }}
          </div>
        </div>
        <!-- <div class="part3">
          {{ item.workContent }}
        </div> -->
      </div>
      <div class="actions">
        <el-button
          type="primary"
          size="mini"
          plain
          @click="editFunc(item)"
          :disabled="!canEdit"
          :title="canEdit ? '' : isSpecific ? '投递岗位后无法再更改简历' : '请取消投递后再更改简历'"
          >编辑</el-button
        >
        <el-button
          type="primary"
          size="mini"
          plain
          @click="deleteFunc(item)"
          :disabled="!canEdit"
          :title="canEdit ? '' : isSpecific ? '投递岗位后无法再更改简历' : '请取消投递后再更改简历'"
          >删除</el-button
        >
      </div>
    </div>
  </div>
  <el-form v-show="visible" ref="formRef" :model="formData" :rules="rules" label-width="130px" class="form">
    <div v-show="false">
      <!-- 简历id -->
      <el-form-item label="basicId：" prop="basicId">
        <el-input v-model="formData.basicId" />
      </el-form-item>
      <!-- 关系id -->
      <el-form-item label="Id：" prop="id">
        <el-input v-model="formData.id" />
      </el-form-item>
    </div>
    <el-row>
      <el-col :span="11">
        <el-form-item :label="WORK.startDate + ':'" prop="startDate">
          <el-date-picker v-model="formData.startDate" type="month" placeholder="请选择开始时间" style="width: 100%"></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item :label="WORK.endDate + ':'" prop="endDate">
          <el-date-picker v-model="formData.endDate" type="month" placeholder="请选择结束时间" style="width: 100%"></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item :label="WORK.workUnit + ':'" prop="workUnit">
          <el-input v-model="formData.workUnit" placeholder="请填写单位名称" :maxlength="50" clearable style="width: 100%" />
        </el-form-item>
      </el-col>
      <!-- <el-col :span="11">
        <el-form-item :label="WORK.department + ':'" prop="department">
          <el-input v-model="formData.department" placeholder="请填写部门" :maxlength="50" clearable style="width: 100%" />
        </el-form-item>
      </el-col> -->
      <el-col :span="11">
        <el-form-item :label="WORK.position + ':'" prop="position">
          <el-input v-model="formData.position" placeholder="请填写职务" :maxlength="50" clearable style="width: 100%" />
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item :label="WORK.witness + ':'" prop="witness">
          <el-input v-model="formData.witness" :placeholder="`请填写${WORK.witness}`" :maxlength="50" clearable style="width: 100%" />
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item :label="WORK.witnessNumber + ':'" prop="witnessNumber">
          <el-input v-model="formData.witnessNumber" :placeholder="`请填写${WORK.witnessNumber}`" :maxlength="50" clearable style="width: 100%" />
        </el-form-item>
      </el-col>
    </el-row>
    <!-- <el-form-item :label="WORK.workContent + ':'" prop="workContent">
      <el-input
        v-model="formData.workContent"
        placeholder="请填写工作内容，可填写项目经历（包括项目名称、职责等），不超过1000字"
        clearable
        :rows="10"
        :maxlength="maxCount"
        show-word-limit
        resize="none"
        type="textarea"
        style="width: 90%"
      />
    </el-form-item> -->
    <el-form-item class="submit" label-width="0">
      <el-button type="primary" @click="onSubmit">保存</el-button>
      <el-button @click="onReset">取消</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { reactive, watch, onMounted, toRefs } from 'vue';
import { useRouter } from 'vue-router';
import Info from '../../components/Info.vue';
import ApplicantApi from '../../service/api/applicant';
import { formatDate } from '../../utils/tools';
import { ElMessage } from 'element-plus';
import { WORK } from '../../utils/resume';
import { validatePhoneNumber } from '../../utils/operation';

export default {
  name: 'Work',
  components: { Info },
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
    isSpecific: {
      type: Boolean,
      default: false,
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['callback', 'update:modelValue'],
  setup(props, context) {
    const state = reactive({
      workList: [],
      visible: false,
      formRef: null,
      formData: {},
      maxCount: 1000,
      rules: {
        startDate: [{ required: true, message: WORK.startDate + '必填', trigger: 'change' }],
        endDate: [{ required: true, message: WORK.endDate + '必填', trigger: 'change' }],
        workUnit: [{ required: true, message: WORK.workUnit + '必填', trigger: 'change' }],
        // department: [{ required: true, message: WORK.department + '必填', trigger: 'change' }],
        position: [{ required: true, message: WORK.position + '必填', trigger: 'change' }],
        witness: [{ required: true, message: WORK.witness + '必填', trigger: 'change' }],
        witnessNumber: [
          { required: true, message: WORK.witnessNumber + '必填', trigger: 'change' },
          { validator: validatePhoneNumber, trigger: 'blur' },
        ],
        // workContent: [{ required: true, message: WORK.workContent + '必填', trigger: 'change' }],
      },
    });
    watch(
      () => props.modelValue,
      () => {
        state.workList = props.modelValue.cvRecordList || [];
      },
    );

    const editFunc = (item) => {
      if (!props.modelValue.id) {
        return ElMessage.warning('请先填写基本信息');
      }
      if (!item) {
        state.formData = { basicId: props.modelValue.id };
      } else {
        state.formData = { ...item, basicId: props.modelValue.id };
      }
      state.visible = true;
    };
    const deleteFunc = async (item) => {
      try {
        await ApplicantApi.deleteResumeWork(item.id);
        context.emit('callback');
        ElMessage.success('删除成功');
      } catch (e) {
        console.error(e);
      }
    };

    const onSubmit = () => {
      state.formRef.validate(async (valid) => {
        if (valid) {
          const formData = { ...state.formData };
          Object.entries(formData).forEach(([key, value]) => {
            if (value instanceof Date) {
              formData[key] = formatDate('YYYY-MM-DD', value);
            }
          });
          try {
            if (formData.id) {
              await ApplicantApi.updateResumeWork([formData]);
            } else {
              delete formData.id;
              await ApplicantApi.addResumeWork([formData]);
            }
            ElMessage.success('保存成功');
            context.emit('callback');
            state.formRef.resetFields();
            state.visible = false;
          } catch (e) {
            console.error(e);
          }
        } else {
          return false;
        }
      });
    };
    const onReset = () => {
      state.visible = false;
      state.formRef.resetFields();
    };

    onMounted(() => {});
    return {
      router: useRouter(),
      ...toRefs(state),
      onSubmit,
      onReset,
      editFunc,
      deleteFunc,
      formatDate,
      WORK,
    };
  },
};
</script>

<style scoped lang="scss">
.title {
  color: #000;
  font-size: 20px;
  padding: 30px 20px 10px;
  font-weight: 600;
  position: relative;
  ::before {
    content: '';
    position: absolute;
    width: 4px;
    height: 18px;
    background: #409eff;
    left: 8px;
    top: 36px;
  }
}
.desc {
  padding-left: 30px;
  font-size: 14px;
  margin: 7px 0 20px;
  color: #606266;
}
.edu_item {
  display: flex;
  align-items: center;
  line-height: 24px;
  padding: 20px;
  &:hover {
    box-shadow: 0 0 4px 0 rgb(0 0 0 / 30%);
    border-radius: 4px;
  }
  .left {
    flex: 1;
  }
  .part1 {
    display: flex;
    align-items: center;
    // margin-bottom: 10px;
    font-size: 16px;
    // font-weight: 600;
    > div {
      flex: 1;
    }
    .desc {
      font-weight: 400;
      color: #999;
      margin-bottom: 0;
    }
  }
  .part2 {
    font-size: 16px;
    margin-bottom: 6px;
  }
  .part3 {
    white-space: pre-line;
    line-height: 24px;
    font-size: 15px;
  }
  .actions {
    // width: 80px;
    text-align: right;
  }
}
.form {
  position: relative;
  :deep(.el-form-item__content) {
    position: relative;
    .count {
      position: absolute;
      right: 10%;
    }
  }
}
.submit {
  margin-top: 30px;
  text-align: center;
}
</style>
